import { render, staticRenderFns } from "./jiezhen_list.vue?vue&type=template&id=4be0a13e&scoped=true&"
import script from "./jiezhen_list.vue?vue&type=script&lang=js&"
export * from "./jiezhen_list.vue?vue&type=script&lang=js&"
import style0 from "./jiezhen_list.vue?vue&type=style&index=0&id=4be0a13e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0a13e",
  null
  
)

export default component.exports